import { ExperienceProductIssuesDto } from "@intelligems/ig-types";
import { createSlice } from "@reduxjs/toolkit";
import { IExperienceProductIssuesState } from "@src/store/slices/experienceProductIssues/types";

const initialState: IExperienceProductIssuesState = {
  issues: undefined,
  issuesLoading: false,
  showIssuesOnly: false,
  syncingIssues: {},
};

const slice = createSlice({
  name: "experienceProductIssues",
  initialState,
  reducers: (create) => ({
    setExperienceProductIssues: create.reducer<ExperienceProductIssuesDto>(
      (state, action) => {
        const { experienceId, products } = action.payload;
        if (state.issues?.experienceId !== experienceId) {
          state.issues = { experienceId, products: {} };
        }
        for (const [productId, productIssues] of Object.entries(products)) {
          state.issues.products[productId] = productIssues;
        }
        state.issuesLoading = false;
      }
    ),
    startLoadExperienceProductIssues: create.reducer<void>((state) => {
      state.issuesLoading = true;
      state.syncingIssues = {};
    }),
    addExperienceProductIssuesSyncing: create.reducer<string[]>(
      (state, action) => {
        for (const issueKey of action.payload) {
          state.syncingIssues[issueKey] = true;
        }
      }
    ),
    removeExperienceProductIssuesSyncing: create.reducer<string[]>(
      (state, action) => {
        for (const issueKey of action.payload) {
          delete state.syncingIssues[issueKey];
        }
      }
    ),
    setShowIssuesOnly: create.reducer<boolean>((state, action) => {
      state.showIssuesOnly = action.payload;
    }),
  }),
  selectors: {
    getExperienceProductIssues: (state) => state.issues,
    areExperienceProductIssuesLoading: (state) => state.issuesLoading,
    getShowIssuesOnly: (state) => state.showIssuesOnly,
    getExperienceProductSyncingIssues: (state) => state.syncingIssues,
  },
});

export const experienceProductIssuesReducer = slice.reducer;

export const {
  setExperienceProductIssues,
  startLoadExperienceProductIssues,
  addExperienceProductIssuesSyncing,
  removeExperienceProductIssuesSyncing,
  setShowIssuesOnly,
} = slice.actions;

export const {
  getExperienceProductIssues,
  areExperienceProductIssuesLoading,
  getShowIssuesOnly,
  getExperienceProductSyncingIssues,
} = slice.selectors;
